import * as React from 'react';
import * as Redux from 'redux';
import { ErrorTypes, IPopupErrorModel } from '../../state-helpers/popup-error';
import { setPopupErrorText, setPopupErrorType } from '../../actions/index';

export interface IProps {
    warningHtml: string,
    dismissLabel: string,

    onDismiss: () => void
}

/// <summary>
/// This is the popup for the api errors. Relies on the global fetch action to set errors correct errors in state. Must add popup model to current app state,
/// add component to app, and set the epi props model to inherit from the global site settings props model
/// </summary>
export class PopupWarning extends React.Component<IProps, any> {

    render() {
        return (
            <div className="alert-warning-search" role="dialog" >
                <div className="alert-warning-search-content">
                    <div className="alert-warning-search-content-icon">
                        <svg>
                            <use xlinkHref="#icon-warning"></use>
                        </svg>
                    </div>
                    <div className="alert-warning-search-content-text" dangerouslySetInnerHTML={{ __html: this.props.warningHtml }} />
                </div>
                <div className="alert-warning-search-close" onClick={this.props.onDismiss}>
                    <p><u>{this.props.dismissLabel}</u></p>
                </div>
            </div>
        );
    }
}